import React from "react";
import SEO from "../components/SEO";
import blogData from "../data/blog.json";
import { NavLink } from "react-router-dom";
import { logActivity } from "../utils/activity";

export default function Blog() {
  const featuredArticle = blogData.articles?.[0];

  return (
    <div className="bg-slate-50">
      <SEO
        title={blogData.seo?.title}
        description={blogData.seo?.description}
        ogType="website"
        ogImage={blogData.seo?.ogImage}
        article={
          featuredArticle
            ? {
                headline: featuredArticle.title,
                description: featuredArticle.description,
                keywords: featuredArticle.keywords,
                articleSection: featuredArticle.articleSection,
                wordCount: featuredArticle.wordCount,
              }
            : null
        }
      />
      <section className="section-padding mx-auto w-full max-w-6xl">
        {/* <!-- Replace with dynamic content from JSON --> */}
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          Blog
        </p>
        <h1 className="page-title mt-3">
          {blogData.headline}
        </h1>
        <p className="mt-4 text-lg text-slate-600">
          Insights and tips from the Manage Your Vastu team.
        </p>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto grid w-full max-w-6xl gap-10 md:grid-cols-[1.5fr_0.5fr]">
          <div className="grid gap-6">
            {/* <!-- Replace with dynamic content from JSON --> */}
            {blogData.articles.map((article) => (
              <article
                key={article.title}
                className="card p-6"
              >
                <div className="flex h-40 items-center justify-center rounded-2xl border border-dashed border-slate-300 text-sm text-slate-400">
                  Image placeholder
                </div>
                <div className="mt-4 flex items-center gap-3 text-xs text-slate-500">
                  <span>{article.category}</span>
                  <span>•</span>
                  <span>{article.date}</span>
                </div>
                <h2 className="mt-3 text-xl font-semibold text-slate-900">
                  {article.title}
                </h2>
                <p className="mt-2 text-sm text-slate-600">
                  {article.description}
                </p>
                <button
                  className="btn btn-secondary mt-4 w-fit"
                  onClick={() =>
                    logActivity("blog_open", { title: article.title })
                  }
                >
                  Read with Manage Your Vastu →
                </button>
              </article>
            ))}
          </div>

          <aside className="space-y-4">
            <div className="card p-6">
              <p className="text-sm font-semibold text-slate-900">
                Recent posts
              </p>
              <ul className="mt-3 space-y-2 text-sm text-slate-600">
                {/* <!-- Replace with dynamic content from JSON --> */}
                {blogData.recent.map((title) => (
                  <li key={title} className="hover:text-amber-600">
                    {title}
                  </li>
                ))}
              </ul>
            </div>
            <div className="card p-6 text-sm text-slate-500">
              Subscribe for weekly tips from Manage Your Vastu.
              <NavLink
                to="/features"
                className="mt-3 block text-sm text-amber-600 transition hover:text-amber-500"
                onClick={() =>
                  logActivity("internal_link", { from: "blog", to: "features" })
                }
              >
                {blogData.featuresLinkLabel}
              </NavLink>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
